export function getFileSize(sizeByte: number | undefined) {
  if (typeof sizeByte == 'undefined') return '--'
  if (sizeByte < 1024) {
    return sizeByte + 'B'
  } else if (sizeByte < 1024 * 1024) {
    return (sizeByte / 1024).toFixed(2) + 'KB'
  } else if (sizeByte < 1024 * 1024 * 1024) {
    return (sizeByte / 1024 / 1024).toFixed(2) + 'MB'
  } else {
    return (sizeByte / 1024 / 1024 / 1024).toFixed(2) + 'GB'
  }
}

export function mb2GbString(mb: number) {
  return (parseFloat(`${mb}`) / 1024).toFixed(2) + 'GiB'
}

export function toGbStrig(gb: number) {
  return `${gb}GiB`
}
